<template>
    <div>
        <h3 class="Modal__title">Modifier mon mot de passe</h3>
        <form @submit.prevent="handleSubmit" class="FormMaterial m-t-30">
            <input-material @input="value => handleChange('current_password', value)"
                            label="Mot de passe actuel"
                            type="password"
                            v-model="data.current_password"
                            :error="errors.current_password"/>
            <input-material @input="value => handleChange('new_password', value)"
                            label="Nouveau mot de passe"
                            type="password"
                            v-model="data.new_password"
                            :error="errors.new_password"/>
            <input-material @input="value => handleChange('password_confirm', value)"
                            label="Confirmez le mot de passe"
                            type="password"
                            v-model="data.password_confirm"
                            :error="errors.password_confirm"/>

            <div class="text-center m-t-30">
                <button :disabled="loading" type="submit" class="Btn Btn--primary Btn--gradient Btn--shadow">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span v-else>Sauvegarder</span>
                </button>
            </div>
        </form>
    </div>
</template>
<script>
    import Api from "../../../services/Api";
    import validate from "../../../validator/validator";
    import Rules from "../../../validator/rules";
    import {isEmpty} from "../../../utils";
    import InputMaterial from "../../InputMaterial";
    import ModalBus from "../../../eventBus";

    export default {
        components: {InputMaterial},
        data: function () {
            return {
                errors: {},
                loading: false,
                data: {
                    current_password: null,
                    new_password: null,
                    password_confirm: null
                }
            }
        },
        methods: {
            handleChange(name) {
                delete this.errors[name];
            },
            async handleSubmit() {
                this.errors = validate(this.data, {
                    current_password: [Rules.required()],
                    new_password: [Rules.required(), Rules.minLength(6)],
                    password_confirm: [Rules.required(), Rules.same('new_password', 'Les mots de passe ne sont pas identiques.')]
                });

                if (!isEmpty(this.errors)) return;

                this.loading = true;

                try {
                    await Api.put('/account/password', {
                        current_password: this.data.current_password,
                        new_password: this.data.new_password
                    });

                    ModalBus.alertSuccess('Mot de passe modifié !', 'Votre mot de passe a bien été modifié, vous devez désormais vous connecter avec ce dernier.');
                } catch (err) {
                    if (err.response?.data?.errors) {
                        this.errors = err.response.data.errors;
                        this.loading = false;
                    } else {
                        ModalBus.processingError();
                    }
                }
            }
        }
    }
</script>
